import React from 'react';

const KNOWN_VENDORS = [
  {
    id: 'amazon',
    label: 'Amazon',
    match: (url) => /amazon\./i.test(url || ''),
    classes: 'border-yellow-500 text-yellow-700 bg-yellow-50 hover:bg-yellow-100',
    icon: '/images/icons/amazon.svg'
  },
{
  id: 'walmart',
  label: 'Walmart',
  // Matches walmart.com, walmart.ca, and walmrt.us
  match: (url) => /walm(a)?rt\.(com|ca|us)/i.test(url || ''),
  classes: 'border-blue-600 text-blue-700 bg-blue-50 hover:bg-blue-100',
  icon: null
},
  {
    id: 'aliexpress',
    label: 'AliExpress',
    match: (url) => /aliexpress\.(com|us)/i.test(url || ''),
    classes: 'border-red-600 text-red-700 bg-red-50 hover:bg-red-100',
    icon: null
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    match: (url) => /tiktok\.(com|shop)/i.test(url || ''),
    classes: 'border-white text-white bg-black hover:bg-gray-900',
    icon: '/images/icons/tiktok.svg'
  }
];

function detectVendor(url) {
  if (!url) return null;
  const vendor = KNOWN_VENDORS.find(v => v.match(url));
  if (vendor) return vendor;
  return {
    id: 'generic',
    label: 'Shop',
    classes: 'border-indigo-600 text-indigo-700 bg-indigo-50 hover:bg-indigo-100',
    icon: null
  };
}

function normalizeLinks({ link, links }) {
  // links can be:
  // - undefined
  // - string URL
  // - object map: { walmart: '...', aliexpress: '...', tiktok: '...', generic: '...' }
  if (links && typeof links === 'string') {
    return [{ vendor: detectVendor(links), url: links }];
  }
  if (links && typeof links === 'object') {
    const entries = Object.entries(links)
      .filter(([, url]) => !!url)
      .map(([key, url]) => {
        const explicitVendor = KNOWN_VENDORS.find(v => v.id === key);
        const vendor = explicitVendor || detectVendor(url);
        return { key, vendor, url };
      });
    if (entries.length > 0) return entries.map(e => ({ vendor: e.vendor, url: e.url }));
  }
  if (link) {
    return [{ vendor: detectVendor(link), url: link }];
  }
  return [];
}

const BuyButtons = ({ productTitle, link, links, layout = 'stack', size = 'md' }) => {
  const items = normalizeLinks({ link, links });
  if (items.length === 0) return null;

  const baseClasses = 'inline-flex items-center justify-center border-2 font-semibold rounded-md shadow-sm transition';
  const sizeClasses = size === 'lg'
    ? 'px-5 py-3 text-base'
    : size === 'sm'
    ? 'px-3 py-1.5 text-sm'
    : 'px-4 py-2 text-sm';

  const containerClasses = layout === 'inline'
    ? 'flex flex-row flex-wrap gap-2'
    : 'flex flex-col space-y-2';

  return (
    <div className={containerClasses}>
      {items.map(({ vendor, url }, idx) => (
        <a
          key={`${vendor.id}-${idx}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className={`${baseClasses} ${sizeClasses} ${vendor.classes}`}
          aria-label={`Shop ${productTitle || 'product'} on ${vendor.label}`}
        >
          {vendor.icon && (
            <img src={vendor.icon} alt={vendor.label} className="h-5 w-5 mr-2" />
          )}
          {`Shop${productTitle ? ` ${productTitle}` : ''} on ${vendor.label}`}
        </a>
      ))}
    </div>
  );
};

export default BuyButtons;
